module.exports = __webpack_public_path__ + "img/home_icon_wscience@2x.4c4b6e1d.png";